import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private showModalSubject = new BehaviorSubject<boolean>(true);
  showModal$ = this.showModalSubject.asObservable();

  toggleModal(show?: boolean): void {
    if (show !== undefined) {
      this.showModalSubject.next(show);
    } else {
      this.showModalSubject.next(!this.showModalSubject.value);
    }
  }
}
